<section>
  <div class="top-bar-container">
    <div class="search-bar-container">
      <app-search-bar
        [placeholder]="'Buscar en vídeos...'"
        (onSearch)="onSearch($event)"
      ></app-search-bar>
    </div>
    <div class="action-buttons-container">
      <app-rfebm-icon-button
        [iconName]="'video'"
        (onClick)="onUploadVideo()"
      ></app-rfebm-icon-button>
    </div>
  </div>

  <div class="body-container">
    <div class="title-container">
      <h1>Ánalisis de vídeos</h1>
      <div class="action-buttons-container">
        <app-rfebm-icon-button
          [iconName]="'filter'"
          (onClick)="setFilterVisible(!showFilter)"
        ></app-rfebm-icon-button>
        <app-rfebm-icon-button
          [iconName]="'swap'"
          (onClick)="setSortByVisible(!showSortBy)"
        ></app-rfebm-icon-button>
      </div>
    </div>
    <div class="video-grid-container">
      <div
        class="window-overlay-container filter-overlay after-hide"
        [ngClass]="{ hidden: !showFilter }"
      >
        <app-video-filter
          (onFiltersApplied)="applyFilters($event)"
        ></app-video-filter>
      </div>
      <div
        class="window-overlay-container sortby-overlay after-hide"
        [ngClass]="{ hidden: !showSortBy }"
      >
        <app-video-sort-by
          (onSortByApplied)="applySortBy($event)"
        ></app-video-sort-by>
      </div>

      <app-video-grid
        [videoSearchResultListPaginated]="videoSearchResultListPaginated"
      ></app-video-grid>
    </div>
  </div>
</section>
